import { TableProps } from '@insight-health-ai/roseate/components';
import { Appointment, Insurance, Clinic } from 'src/hooks/frontdesk';
import { Tag } from 'antd';

export const getColumns = () => {
  return [
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      width: 200,
    },
    {
      title: 'Date & Time',
      key: 'datetime',
      width: 220,
      render: (_: any, record: Appointment) => (
        <div>
          <div>{record.date}</div>
          <div className="text-gray-500 text-sm">
            {record.start_time} - {record.end_time}
          </div>
        </div>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (status: string) => {
        let color = 'default';
        if (status === 'Scheduled') {
          color = 'green';
        } else if (status === 'Cancelled') {
          color = 'red';
        }
        return <Tag color={color}>{status}</Tag>;
      },
    },
    {
      title: 'Insurance',
      dataIndex: 'insurance',
      key: 'insurance',
      width: 150,
      render: (insurance: Insurance) => (
        <div>
          <div>{insurance.name}</div>
        </div>
      ),
    },
    {
      title: 'Clinic',
      dataIndex: 'clinic',
      key: 'clinic',
      width: 150,
      render: (clinic: Clinic) => (
        <div>
          <div>{clinic.name}</div>
        </div>
      ),
    },
  ].map((column) => {
    return column;
  }) satisfies TableProps<Appointment>['columns'];
};
